<template>
    <div class="content" style="height: auto">
        <div class="content-block" v-for="(item, i) in navConfig" :key="i" @click="handleClick(i)">
            <div class="content-img"><img :src="item.icon" :alt="item.name"></div>
            <p>{{ item.name }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "topNav2",
    props: {
        navConfig: Array
    },
    setup(props, { emit }) {
        const handleClick = (i) => {
            emit('navClick', i)
        }
        return {
            handleClick
        }
    }
}
</script>

<style scoped lang="stylus">
    .content {
        width 100%
        height 65px
        margin 10px 0
        display flex
        justify-content space-evenly
        .content-block {
            //width 50px
            height 65px
            text-align center
            color #575757
            font-size 12px
            font-weight bolder
            .content-img {
                width 45px
                height 45px
                margin 0 auto
                text-align center
                line-height 45px
                border-radius 8px
                background-color #78B13F
            }
        }
        .content-block p {
            margin-top 3px
        }
    }
</style>